export const headerName = {
  add: "Добавить медицинские показания (ограничения)",
  edit: "Редактировать медицинские показания (ограничения)",
};
export const medConditionsInputs = {
  name: {
    key: "name",
    label: "Наименование медицинского показания (ограничения)",
    type: "text",
    required: true,
  },
};
export const getMedConditionsInputsInputs = () => medConditionsInputs;
